(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shled-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const megaMenus = Array.from(document.querySelectorAll('.shled-mega'));
  megaMenus.forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      megaMenus.forEach((other) => {
        if (other !== menu) other.open = false;
      });
    });
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.shled-mega')) return;
    megaMenus.forEach((menu) => { menu.open = false; });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    megaMenus.forEach((menu) => { menu.open = false; });
  });
  const params = new URLSearchParams(window.location.search);
  const previewThemeId = params.get('preview_theme_id');
  if (!previewThemeId) return;
  document.querySelectorAll('a[href^="/"]').forEach((link) => {
    const url = new URL(link.getAttribute('href'), window.location.origin);
    if (!url.searchParams.has('preview_theme_id')) {
      url.searchParams.set('preview_theme_id', previewThemeId);
      link.setAttribute('href', url.pathname + url.search + url.hash);
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
